import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { LoadingService } from 'src/app/core/services/loader.service';
import { SideNavService } from '../../side-nav-components/service/sidenav.service';
import { UsersService } from '../../users/services/users.service';

@Component({
  selector: 'app-header-notification-popup',
  templateUrl: './header-notification-popup.component.html',
  styleUrls: ['./header-notification-popup.component.scss'],
})
export class HeaderNotificationPopupComponent implements OnInit {
  token;
  allNotification = [];
  accountId: string;
  contactId: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<HeaderNotificationPopupComponent>,
    public auth: AuthenticationService,
    private loadingService: LoadingService,
    private userService: UsersService,
    private sidenavService: SideNavService
  ) {}

  ngOnInit(): void {
    this.token = this.auth.getUserAccessToken();
    this.accountId = this.auth.getUserAccountId();
    this.contactId = this.auth.getPrimaryUserId();
    this.allNotification = this.data.allNotification;
  }
  // gotoNotificationPage() {
  //   this.showComingSoon();
  //   // this.dialogRef.close();
  //   // // console.log(this.router.url);
  //   // if (this.router.url !== '/notification') {
  //   //   this.auth.setNotificationBackUrl(this.router.url);
  //   // }
  //   // this.router.navigate(['/notification']);
  // }
  showComingSoon() {
    this.auth.showSnackBarMsg('Coming Soon!')
  }
}
